import { registerCoordinatorInstruction } from "@crunchdao/sdk";
import { EnhancedBaseCommand } from "@crunchdao/shared-cli";

export class RegisterCommand extends EnhancedBaseCommand {
  async execute(name: string): Promise<void> {
    try {
      await this.executeOrProposeInstructions(async () => {
        return [await registerCoordinatorInstruction(this.program, name, this.getSigner())];
      }, `Registering coordinator ${name}`);

      if (!this.isMultisigMode()) {
        this.success("Coordinator registered successfully", {
          coordinatorName: name,
          ownerAddress: this.provider.wallet.publicKey.toBase58(),
        });
      }
    } catch (error) {
      this.handleRegisterError(name, error);
    }
  }

  private handleRegisterError(name: string, error: any): never {
    // Check for coordinator already registered error
    if (
      error.transactionLogs &&
      error.transactionLogs.some(
        (log: string) => log.includes("already in use") && log.includes("Allocate: account Address")
      )
    ) {
      const coordinatorAddress = this.provider.wallet.publicKey.toBase58();

      const customError = new Error(
        `Coordinator already registered for address ${coordinatorAddress}`
      );
      customError.name = "CoordinatorAlreadyRegisteredError";
      (customError as any).code = "COORDINATOR_ALREADY_REGISTERED";
      (customError as any).details = {
        coordinatorAddress,
        coordinatorName: name,
        originalError: error.message || String(error),
      };

      return this.handleError(customError);
    }

    // Fall back to generic transaction error handling
    return this.handleTransactionError(error);
  }
}
